var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveMember(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 16C26 18.2091 24.2091 20 22 20C19.7909 20 18 18.2091 18 16C18 13.7909 19.7909 12 22 12C24.2091 12 26 13.7909 26 16Z",
    fill: "#00C48C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6782 23.5028C25.2051 23.5085 24.7642 23.5258 24.3799 23.5774C23.737 23.6639 23.0334 23.8705 22.4519 24.4519C21.8705 25.0333 21.6639 25.737 21.5775 26.3799C21.4998 26.9576 21.4999 27.6635 21.5 28.414V28.586C21.4999 29.3365 21.4998 30.0424 21.5775 30.6201C21.6381 31.0712 21.7579 31.5522 22.0249 32C22.0166 32 22.0083 32 22 32C14 32 14 29.9853 14 27.5C14 25.0147 17.5817 23 22 23C23.3262 23 24.577 23.1815 25.6782 23.5028Z",
    fill: "#00C48C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 32C24.8501 32 24.0251 32 23.5126 31.4874C23 30.9749 23 30.1499 23 28.5C23 26.8501 23 26.0251 23.5126 25.5126C24.0251 25 24.8501 25 26.5 25C28.1499 25 28.9749 25 29.4874 25.5126C30 26.0251 30 26.8501 30 28.5C30 30.1499 30 30.9749 29.4874 31.4874C28.9749 32 28.1499 32 26.5 32ZM28.468 27.7458C28.6958 27.518 28.6958 27.1487 28.468 26.9209C28.2402 26.693 27.8709 26.693 27.6431 26.9209L25.7222 28.8417L25.3569 28.4764C25.1291 28.2486 24.7598 28.2486 24.532 28.4764C24.3042 28.7042 24.3042 29.0736 24.532 29.3014L25.3097 30.0791C25.5375 30.307 25.9069 30.307 26.1347 30.0791L28.468 27.7458Z",
    fill: "#00C48C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMember);
export default __webpack_public_path__ + "static/media/active-member.17abd9246df22b5191588fe50ec4caa1.svg";
export { ForwardRef as ReactComponent };